import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import CreatableSelect from 'react-select/creatable';
import Sidebar from './Sidebar';
import '../css/SubmitMission.css';
import API_BASE_URL from '../api';
const initialSkillsOptions = [
  { value: 'java', label: 'Java' },
  { value: 'python', label: 'Python' },
  { value: 'php', label: 'PHP' },
  // Add more skill options as needed
];

const generateReference = async () => {
  let isUnique = false;
  let reference = '';
  const token = localStorage.getItem('authToken');
  
  while (!isUnique) {
    reference = `REF-${Math.floor(1000 + Math.random() * 9000)}`;
    const response = await axios.get(`${API_BASE_URL}/api/missions/check-reference/${reference}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    isUnique = response.data.isUnique;
  }

  return reference;
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const SubmitMission = () => {
  const [missionData, setMissionData] = useState({
    name: '',
    description: '',
    experience: '',
    location: '',
    telecommute: '',
    startDate: '',
    asap: false,
    budgetTJM: 450,
    skills: [],
    reference: '',
    assignedUserId: localStorage.getItem('userId'),
    assignedUserName: localStorage.getItem('userName'),
    status: 'published' // default status as published
  });

  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [skillsOptions, setSkillsOptions] = useState(initialSkillsOptions);
  const navigate = useNavigate();

  const arrive = localStorage.getItem('arrive'); // Get arrive value from localStorage

  useEffect(() => {
    if (arrive === 'Freelance') {
      // Redirect or show an error message if the user is a freelancer
      navigate('/dashboard'); // or navigate to another page
    } else {
      const fetchReference = async () => {
        const reference = await generateReference();
        setMissionData((prevData) => ({
          ...prevData,
          reference
        }));
      };
      fetchReference();
    }
  }, [arrive, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setMissionData({
      ...missionData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleBudgetChange = (e) => {
    setMissionData({
      ...missionData,
      budgetTJM: e.target.value
    });
  };

  const handleBudgetInputChange = (e) => {
    const value = e.target.value;
    if (!isNaN(value) && value >= 100 && value <= 1800) {
      setMissionData({
        ...missionData,
        budgetTJM: value
      });
    }
  };

  const handleDescriptionChange = (newContent) => {
    setMissionData({
      ...missionData,
      description: newContent
    });
  };

  const handleSkillsChange = (selectedOptions) => {
    setMissionData({
      ...missionData,
      skills: selectedOptions.map(option => option.value)
    });
  };

  const handleCreateSkill = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setSkillsOptions([...skillsOptions, newOption]);
    setMissionData({
      ...missionData,
      skills: [...missionData.skills, inputValue]
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('authToken');
    try {
      const response = await axios.post(`${API_BASE_URL}/api/missions`, missionData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setSuccess('besoin publié avec succès');
      setError('');
      navigate(`/missions/${response.data._id}`);
    } catch (error) {
      console.error('Error creating mission:', error);
      setError('Erreur lors de la soumission du besoin');
      setSuccess('');
    }
  };



  return (
    <div className="submit-mission-container">
      <Sidebar />
      <div className="main-content">
        <div className="mission-container">
          <div className="mission-header">
            <h2>Publier une mission</h2>
          </div>
          <form className="submit-mission-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Titre du besoin</label>
              <input
                type="text"
                id="name"
                name="name"
                value={missionData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="reference">Votre référence</label>
              <input
                type="text"
                id="reference"
                name="reference"
                value={missionData.reference}
                readOnly
              />
            </div>
            <div className="form-group">
              <label htmlFor="experience">Expérience</label>
              <select
                id="experience"
                name="experience"
                value={missionData.experience}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionner...</option>
                <option value="Moins de 2 ans d'expérience">Moins de 2 ans d'expérience</option>
                <option value="2 à 5 ans d'expérience">2 à 5 ans d'expérience</option>
                <option value="5 à 10 ans d'expérience">5 à 10 ans d'expérience</option>
                <option value="Plus de 10 ans d'expérience">Plus de 10 ans d'expérience</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="location">Lieu d'exécution</label>
              <input
                type="text"
                id="location"
                name="location"
                value={missionData.location}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="startDate">Date de début</label>
              <input
                type="date"
                id="startDate"
                name="startDate"
                value={formatDate(missionData.startDate)}
                onChange={handleChange}
                disabled={missionData.asap}
                required={!missionData.asap}
              />
            </div>
            <div className="form-group asap-checkbox">
              <label htmlFor="asap">ASAP</label>
              <input
                type="checkbox"
                id="asap"
                name="asap"
                checked={missionData.asap}
                onChange={handleChange}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="telecommute">Télétravail</label>
              <select
                id="telecommute"
                name="telecommute"
                value={missionData.telecommute}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionner...</option>
                <option value="Possible">Possible</option>
                <option value="Non">Non</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="budgetTJM">Budget TJM</label>
              <div className="budget-slider">
                <input
                  type="range"
                  id="budgetTJM"
                  name="budgetTJM"
                  min="100"
                  max="1800"
                  value={missionData.budgetTJM}
                  onChange={handleBudgetChange}
                  required
                />
                <input
                  type="number"
                  id="budgetTJMInput"
                  name="budgetTJMInput"
                  min="100"
                  max="1800"
                  value={missionData.budgetTJM}
                  onChange={handleBudgetInputChange}
                  required
                />
                <span>{`${missionData.budgetTJM}€`}</span>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="skills">Compétences attendues</label>
              <CreatableSelect
                id="skills"
                name="skills"
                isMulti
                options={skillsOptions}
                onChange={handleSkillsChange}
                onCreateOption={handleCreateSkill}
                value={skillsOptions.filter(option => missionData.skills.includes(option.value))}
                placeholder="Rechercher une compétence..."
                required
              />
            </div>
            <div className="form-group full-width">
              <label htmlFor="description">Description du poste</label>
              <JoditEditor
                value={missionData.description}
                onChange={handleDescriptionChange}
                required
              />
            </div>
            {error && <div className="alert alert-danger mt-3">{error}</div>}
            {success && <div className="alert alert-success mt-3">{success}</div>}
            <div className="form-actions">
              <button type="submit" className="publish-button">
                Publier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SubmitMission;
